import { MapPin } from 'lucide-react';

export interface ScheduleLocationOption {
  id: string;
  name: string;
}

interface ScheduleLocationFilterProps {
  value: string;
  onChange: (value: string) => void;
  locations: ScheduleLocationOption[];
  className?: string;
}

/** Compact location picker for calendar card toolbars — full width on mobile, constrained on larger screens. */
export function ScheduleLocationFilter({
  value,
  onChange,
  locations,
  className = '',
}: ScheduleLocationFilterProps) {
  return (
    <div
      className={`relative flex w-full min-w-0 items-center sm:w-auto sm:max-w-[min(100%,15rem)] ${className}`}
    >
      <MapPin
        className="pointer-events-none absolute left-2.5 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden
      />
      <select
        aria-label="Filter schedule by location"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 w-full min-w-0 truncate rounded-md border border-input bg-background py-1.5 pl-8 pr-2 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:max-w-[15rem]"
      >
        <option value="">All locations</option>
        {locations.map((loc) => (
          <option key={loc.id} value={loc.id}>
            {loc.name}
          </option>
        ))}
      </select>
    </div>
  );
}
